<template>
  <div class="order">
    <div class="order-task">
      <div
        v-for="(item, index) in taskList"
        :key="index"
        class="task-one"
        :class="item.process ? 'finished' : index === 2 ? 'ing' : ''"
      >
        {{ index + 1 }}. {{ item.nameEn }}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color: #fff"></i>
        </div>
      </div>
      <!-- <div class="task-one">
        Done
        <div class="box"><div></div></div>
      </div> -->
      <div class="line"></div>
    </div>
    <div class="order-header">
      <p>Exhibition Application/参展申请</p>
      <span></span>
      <p>Select Order/选择订单</p>
    </div>

    <!-- 展团 -->
    <div class="order-exhall">
      <p class="exhall-header">
        Please select your exhibition group/请选择您的展团
      </p>

      <div class="tabs">
        <div class="tabs-top">
          <Row :gutter="24">
            <Col span="3" v-for="(item, index) in listPavilion" :key="index">
              <div
                class="tag"
                :class="
                  selectedExhall && selectedExhall.id === item.id
                    ? 'active'
                    : ''
                "
                v-if="item.languageType === '英文' && item.isEnable"
                @click="
                  areaName = item.name;
                  areaIndex = index;
                  getOrder(item);
                "
              >
                <span>{{ item.name }}</span>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <!-- 展区 -->
    <div class="order-exhall">
      <!-- <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '否'">Please select exhibition area</p>
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '是'">请选择组团</p> -->
      <!-- <div class="exhall-list">
        <template v-if="list && list.length > 0">
          <div class="list-one" v-for="(item,index) in list" :key="index" @click="select(item)" :class="selectedExhall.id === item.id?'selected':''" v-if="item.typeLanguage=='英文'">
            <span>{{item.name}}</span>
          </div>
        </template>
<div v-else style="width:100%;line-height:200px;text-align:center;">暂无数据！</div>
</div> -->
      <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '否'">
        Please select booth type/请选择展位类型
      </p>
      <!-- <p class="exhall-header" v-if="orderInfo && orderInfo.isAgent === '是'">请选择组团类型</p> -->
      <div class="booth-list">
        <template v-if="boothList && boothList.length">
          <div
            class="booth-one"
            :class="
              chooseBooth && chooseBooth.id === item.id ? 'chooseboothOne' : ''
            "
            v-for="(item, index) in boothList"
            :key="index"
            v-if="item.isEnable"
            @click="choose(item)"
          >
            <div class="f">
              <p :title="item.name">{{ item.name }}</p>
              <p :title="item.remark">{{ item.remark }}</p>
            </div>
            <div class="s">
              <!-- <p>媒体推广费 RMB 3400.00</p> -->
              <p></p>
              <p v-if="orderInfo && orderInfo.isAgent === '否'">
                {{ item.price }}{{ item.currencyKind }}/{{ item.unit }}
              </p>
            </div>
            <div class="t">
              Width/面宽：<InputNumber
                :max="999999999"
                :min="0"
                v-model="item.width1"
                @on-change="(v) => changeWidth1(v, index)"
              ></InputNumber>
              × Depth/进深：<InputNumber
                :max="999999999"
                :min="0"
                v-model="item.width2"
                @on-change="(v) => changeWidth2(v, index)"
                >></InputNumber
              >
              = {{ item.width1 * item.width2 }} ㎡
            </div>
            <div class="l" v-if="orderInfo && orderInfo.isAgent === '否'">
              <span v-if="item.boothArea > 1"
                >Total：{{
                  (
                    (item.width1 * item.width2 * item.price) /
                    item.boothArea
                  ).toFixed()
                }}{{ item.currencyKind }}</span
              >
              <span v-else
                >Total：{{ item.width1 * item.width2 * item.price }}
                {{ item.currencyKind }}</span
              >
            </div>
            <div
              class="choose"
              :class="
                chooseBooth && chooseBooth.id === item.id ? 'choosed' : ''
              "
            >
              <i class="icon iconfont icon-duigou"></i>
            </div>
          </div>
        </template>
        <div v-else style="width: 100%; line-height: 200px; text-align: center">
          No data！
        </div>
      </div>
    </div>
    <!-- {{chooseBooth}} -->
    <!-- {{selectedExhall}} -->

    <!-- 增值服务 -->

    <div class="order-other">
      <p class="other-header" style="margin-bottom: 30px">
        Obligatory/固定费用
      </p>
      <template v-if="otherList3 && otherList3.length > 0">
        <!-- <div
          class="other-list 1111"
          v-for="(itm, index) in otherList3"
          :key="'other' + index"
          v-if="itm.groupLanguage === '英文' && itm.isEnable"
        > -->
        <div class="other-list 1111">
          <template>
            <div class="content" v-if="otherList3.length > 0">
              <div
                class="content-one"
                v-for="(itm, index) in otherList3"
                :key="'other' + index"
                v-if="itm.groupLanguage === '英文' && itm.isEnable"
              >
                <div class="title">{{ itm.name }}</div>

                <div class="details">
                  <div class="text">
                    <div class="time"></div>
                    <div class="time" v-if="orderInfo">
                      <span>Price/单价</span>
                      <p
                        style="
                          padding: 5px 0;
                          background: #fff;
                          color: #ff0000;
                          font-size: 14px;
                        "
                      >
                        {{ itm.price }}{{ itm.currencyKind }}/{{ itm.unit }}
                      </p>
                    </div>
                    <div class="time">
                      <span>Unit Price/个数</span>
                      <InputNumber
                        @click.stop.native
                        style="width: 100px"
                        :max="9999999999"
                        @on-change="changeNumber(itm, $event)"
                        :min="0"
                        v-model="itm.cunit"
                        :disabled="true"
                      ></InputNumber>
                      &nbsp;&nbsp;&nbsp;{{ itm.unit }}
                    </div>
                    <!-- <p style="margin-top:30px;" v-if="orderInfo">total: {{itm.minCount*itm.price}} {{itm.pType}}</p> -->
                    <div class="choose choosed">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>

                  <img v-if="itm.netImg" :src="itm.netImg" />
                </div>
              </div>
            </div>
            <div
              v-else
              style="width: 100%; line-height: 200px; text-align: center"
            >
              No data！
            </div>
          </template>
        </div>
      </template>

      <!-- <template v-else-if="otherList3 && otherList3.length > 0 && join == true">
        <div
          class="other-list 22222"
          v-for="(item, index) in otherList3"
          :key="'other' + index"
          v-if="item.typeLanguage === '英文'"
        >
          <template v-if="item.isPack">
            <div class="content" v-if="otherList3.length > 0">
              <div v-for="(itm, idx) in otherList3" :key="idx">
                <div class="content-one">
                  <div class="title">{{ itm.name }}</div>

                  <div class="details">
                    <div class="text" @click="chooseOne(itm, index)">
                      <div class="time"></div>
                      <div class="time" v-if="orderInfo">
                        <span>Price/单价</span>
                        <p
                          style="
                            padding: 5px 0;
                            background: #fff;
                            color: #ff0000;
                            font-size: 14px;
                          "
                        >
                          {{ itm.price }}{{ itm.currencyKind }}/{{ itm.unit }}
                        </p>
                      </div>
                      <div class="time">
                        <span>Unit Price/个数</span>
                        <InputNumber
                          @click.stop.native
                          style="width: 100px"
                          :max="9999999999"
                          @on-change="changeNumber(itm, $event)"
                          :min="0"
                          v-model="itm.cunit"
                          :disabled="true"
                        ></InputNumber>
                        &nbsp;&nbsp;&nbsp;{{ itm.unit }}
                      </div>
                      <p style="margin-top: 30px" v-if="orderInfo">
                        total: {{ itm.cunit * itm.price }}
                        {{ itm.currencyKind }}
                      </p>
                      <div
                        class="choose"
                        :class="
                          chooseOtherArr.indexOf(itm) !== -1 ? 'choosed' : ''
                        "
                      >
                        <i class="icon iconfont icon-duigou"></i>
                      </div>
                    </div>

                    <img v-if="itm.netImg" :src="itm.netImg" />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              style="width: 100%; line-height: 200px; text-align: center"
            >
              No data！
            </div>
          </template>
        </div>
      </template> -->
      <div v-else style="width: 100%; line-height: 200px; text-align: center">
        No data！
      </div>
    </div>

    <div class="order-other" :key="componentKey">
      <p class="other-header" style="margin-bottom: 30px; height: auto">
        Select Online/Offline Valued-added
        Services/请选择线上/线下市场增值服务项目<span
          style="color: #ff0000; display: block"
          >(We will contact you based on your needs to select the content of the
          intended cooperation)</span
        >
      </p>
      <div class="other-online" v-if="onlineFile && onlineFile.downloadLink">
        CMO Program/线上赞助项目：
        <a :href="onlineFile.downloadLink" download target="_blank"
          >Download Online Marketing Valued Added Service</a
        >
      </div>
      <template v-if="otherList && otherList.length > 0">
        <div
          class="other-list"
          v-for="(item, index) in otherList"
          :key="'other' + index"
          v-if="item.groupLanguage === '英文' && item.isEnable"
        >
          <div class="top">
            <div class="l">
              <Checkbox
                size="large"
                @on-change="allChoose(item, $event)"
                v-model="item.isCheck"
              >
              </Checkbox>
              {{ item.name }}
            </div>
            <div
              class="r"
              v-if="!item.isPack && otherList.length > 0"
              @click="(item.isPack = !item.isPack), componentKey++"
            >
              Show More/展开
              <i
                class="icon iconfont icon-expanding"
                style="transform: rotate(90deg)"
              ></i>
            </div>
            <div
              class="r"
              v-else-if="otherList.length > 0"
              @click="(item.isPack = !item.isPack), componentKey++"
            >
              Show Less/收起
              <i
                class="icon iconfont icon-expanding"
                style="transform: rotate(-90deg)"
              ></i>
            </div>
          </div>
          <template v-if="otherList.length > 0 && item.isPack">
            <div class="content" v-if="otherList.length > 0">
              <div class="content-one">
                <div class="title">{{ item.name }}</div>
                <div class="details">
                  <div
                    class="text"
                    @click="chooseOne(item, index)"
                    v-if="item.isEnable"
                  >
                    <div class="time" v-if="orderInfo">
                      <span>Price/价格</span>
                      <p
                        style="
                          padding: 5px 0;
                          background: #fff;
                          color: #ff0000;
                          font-size: 14px;
                        "
                      >
                        {{ item.price }}{{ item.currencyKind }}/{{ item.unit }}
                      </p>
                    </div>
                    <div class="time">
                      <span>Order quantity/订购数量</span>
                      <InputNumber
                        @click.stop.native
                        style="width: 100px"
                        :max="9999999999"
                        @on-change="changeNumber(item, $event)"
                        :min="0"
                        v-model="item.orderNum"
                      ></InputNumber>
                      &nbsp;&nbsp;&nbsp;{{ item.unit }}
                    </div>
                    <p style="margin-top: 30px" v-if="orderInfo">
                      total: {{ item.orderNum * item.price }}
                      {{ item.currencyKind }}
                    </p>
                    <div class="choose" :class="item.isCheck ? 'choosed' : ''">
                      <i class="icon iconfont icon-duigou"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="otherList.length == 0"
              style="width: 100%; line-height: 200px; text-align: center"
            >
              No data！
            </div>
          </template>
        </div>
      </template>
      <div v-else style="width: 100%; line-height: 200px; text-align: center">
        No data！
      </div>

      <div class="other-online" v-if="offlineFile && offlineFile.downloadLink">
        Offline CMO/线下赞助项目 ：
        <a
          :href="
            offlineFile && offlineFile.downloadLink
              ? offlineFile.downloadLink
              : ''
          "
          >Download offline value-added marketing services document</a
        >
      </div>
      <template v-if="otherList2 && otherList2.length > 0">
        <div
          class="other-list"
          v-for="(item, index) in otherList2"
          :key="'other2' + index"
          v-if="item.typeLanguage === '英文' && item.netShow == '显示'"
        >
          <div class="top">
            <!-- <div class="l" @click="allChoose(item)" :class="isAllChoose.indexOf(item.id) !== -1?'l-clicked':''">
              <i class="icon iconfont icon-duigou"></i>
            </div> -->
            <div class="l">
              <Checkbox
                size="large"
                @on-change="allChoose(item, $event)"
                v-model="item.isCheck"
              >
              </Checkbox>
              {{ item.name }}
            </div>
            <div
              class="r"
              v-if="!item.isPack && item.dePjNameList.length > 0"
              @click="item.isPack = !item.isPack"
            >
              Show More/展开
              <i
                class="icon iconfont icon-expanding"
                style="transform: rotate(90deg)"
              ></i>
            </div>
            <div
              class="r"
              v-else-if="item.dePjNameList.length > 0"
              @click="item.isPack = !item.isPack"
            >
              Show Less/收起
              <i
                class="icon iconfont icon-expanding"
                style="transform: rotate(-90deg)"
              ></i>
            </div>
          </div>
          <template v-if="item.isPack && item.dePjNameList.length > 0">
            <div
              class="content"
              v-if="item.dePjNameList && item.dePjNameList.length > 0"
            >
              <div v-for="(itm, idx) in item.dePjNameList" :key="idx">
                <div class="content-one" v-if="itm.pType == currency">
                  <div class="title">{{ itm.pjName }}</div>
                  <div class="details">
                    <div
                      class="text"
                      @click="chooseOne(itm, index)"
                      v-if="item.netShow !== '显示且必选'"
                    >
                      <div class="time">
                        <span v-if="itm.durationType === '时间段'"
                          >Select Date/选择时间段</span
                        >
                        <span v-if="itm.durationType === '时长'"
                          >Select Hours/选择时长</span
                        >
                        <DatePicker
                          v-if="itm.durationType === '时间段'"
                          format="yyyy-MM-dd"
                          style="width: 230px"
                          type="datetimerange"
                          placeholder="Start Time ~ End Time"
                          :options="itm.options"
                          v-model="itm.durationValue"
                          @click.stop.native
                        ></DatePicker>
                        <template v-if="itm.durationType === '时长'">
                          <Select
                            v-model="itm.durationValue"
                            style="width: 100px"
                            @click.stop.native
                          >
                            <Option
                              v-for="im in itm.durationList"
                              :value="im"
                              :key="im"
                              >{{ im }}</Option
                            > </Select
                          >&nbsp;&nbsp;&nbsp;{{ itm.durationUnit }}
                        </template>
                      </div>
                      <div class="time" v-if="orderInfo">
                        <span>Price/价格</span>
                        <p
                          style="
                            padding: 5px 0;
                            background: #fff;
                            color: #ff0000;
                            font-size: 14px;
                          "
                        >
                          {{ itm.price }}{{ itm.pType }}/{{ itm.cunit }}
                        </p>
                      </div>
                      <div class="time">
                        <span>Order quantity/订购数量</span>
                        <InputNumber
                          @click.stop.native
                          style="width: 100px"
                          :max="9999999999"
                          @on-change="changeNumber(itm, $event)"
                          :min="0"
                          v-model="itm.orderNum"
                        ></InputNumber>
                        &nbsp;&nbsp;&nbsp;{{ itm.cunit }}
                      </div>
                      <p style="margin-top: 30px" v-if="orderInfo">
                        Total/合计: {{ itm.orderNum * itm.price }}
                        {{ itm.pType }}
                      </p>
                      <div
                        class="choose"
                        :class="
                          chooseOtherArr.indexOf(itm) !== -1 ? 'choosed' : ''
                        "
                      >
                        <i class="icon iconfont icon-duigou"></i>
                      </div>
                    </div>
                    <div class="text" v-else>
                      <div class="time">
                        <span v-if="itm.durationType === '时间段'"
                          >Select Date/选择时间段</span
                        >
                        <span v-if="itm.durationType === '时长'"
                          >Select Hours/选择时长</span
                        >
                        <DatePicker
                          v-if="itm.durationType === '时间段'"
                          format="yyyy-MM-dd"
                          style="width: 230px"
                          type="datetimerange"
                          placeholder="Start Time ~ End Time"
                          :options="itm.options"
                          v-model="itm.durationValue"
                          @click.stop.native
                          :disabled="true"
                        >
                        </DatePicker>
                        <template v-if="itm.durationType === '时长'">
                          <Select
                            v-model="itm.durationValue"
                            style="width: 100px"
                            @click.stop.native
                            :disabled="true"
                          >
                            <Option
                              v-for="im in itm.durationList"
                              :value="im"
                              :key="im"
                              >{{ im }}</Option
                            > </Select
                          >&nbsp;&nbsp;&nbsp;{{ itm.durationUnit }}
                        </template>
                      </div>
                      <div class="time" v-if="orderInfo">
                        <span>Price/价格</span>
                        <p
                          style="
                            padding: 5px 0;
                            background: #fff;
                            color: #ff0000;
                            font-size: 14px;
                          "
                        >
                          {{ itm.price }}{{ itm.pType }}/{{ itm.cunit }}
                        </p>
                      </div>
                      <div class="time">
                        <span>Order quantity/订购数量</span>
                        <InputNumber
                          @click.stop.native
                          style="width: 100px"
                          :max="9999999999"
                          :min="1"
                          v-model="itm.orderNum"
                          :disabled="true"
                        ></InputNumber>
                        &nbsp;&nbsp;&nbsp;{{ itm.cunit }}
                      </div>
                      <p style="margin-top: 30px" v-if="orderInfo">
                        Total: {{ itm.orderNum * itm.price }} {{ itm.pType }}
                      </p>
                      <div class="choose" :class="'choosed'">
                        <i class="icon iconfont icon-duigou"></i>
                      </div>
                    </div>
                    <img v-if="itm.netImg" :src="itm.netImg" />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              style="width: 100%; line-height: 200px; text-align: center"
            >
              No data！
            </div>
          </template>
        </div>
      </template>
      <div
        v-else-if="offlineFile && offlineFile.downloadLink"
        style="width: 100%; line-height: 200px; text-align: center"
      >
        No data！
      </div>
      <div class="total" v-if="join">
        <p>
          Sum of Online/Offline Valued-added
          Services/线上线下市场增值服务订单小计：
          <span>{{ otherTotalPrice }}</span> {{ currency }}
        </p>
        <p style="margin-top: 20px">
          Sum of Booth Orders/展位订单小计：
          <span>
            <template v-if="chooseBooth && chooseBooth.standstall <= 1">{{
              chooseBooth.width1 * chooseBooth.width2 * chooseBooth.price
            }}</template>
            <template
              v-else-if="
                chooseBooth &&
                chooseBooth.standstall > 1 &&
                (chooseBooth.cunit.indexOf('㎡') != -1 ||
                  chooseBooth.cunit.indexOf('平米') != -1 ||
                  chooseBooth.cunit.indexOf('平方米') != -1)
              "
              >{{
                (
                  (chooseBooth.width1 *
                    chooseBooth.width2 *
                    chooseBooth.price) /
                  chooseBooth.standstall
                ).toFixed()
              }}</template
            >
            <template v-else>0</template></span
          >
          {{ currency }}
        </p>
        <p style="margin-top: 20px">
          Obligatory/固定费用: <span>{{ gudingprice }}</span
          >{{ currency }}
        </p>
        <p style="margin-top: 20px">
          Total:
          <span style="font-size: 20px; font-weight: bold">
            <template v-if="chooseBooth && chooseBooth.standstall <= 1">{{
              chooseBooth.width1 * chooseBooth.width2 * chooseBooth.price +
              otherTotalPrice +
              gudingprice
            }}</template>
            <template
              v-else-if="
                chooseBooth &&
                chooseBooth.standstall > 1 &&
                (chooseBooth.cunit.indexOf('㎡') != -1 ||
                  chooseBooth.cunit.indexOf('平米') != -1 ||
                  chooseBooth.cunit.indexOf('平方米') != -1)
              "
              >{{
                (
                  (chooseBooth.width1 *
                    chooseBooth.width2 *
                    chooseBooth.price) /
                    chooseBooth.standstall +
                  otherTotalPrice +
                  gudingprice
                ).toFixed()
              }}</template
            >
            <template v-else>{{ otherTotalPrice + gudingprice }}</template>
          </span>
          {{ currency }}
        </p>
      </div>
      <div class="total" v-else>
        <p>
          Sum of Online/Offline Valued-added
          Services/线上线下市场增值服务订单小计：
          <span>{{ otherTotalPrice }}</span> {{ currency }}
        </p>
        <p style="margin-top: 20px">
          Sum of Booth Orders/展位订单小计：
          <span>
            <template v-if="chooseBooth">{{
              chooseBooth.boothArea > 1
                ? (
                    (chooseBooth.width1 *
                      chooseBooth.width2 *
                      chooseBooth.price) /
                    chooseBooth.boothArea
                  ).toFixed()
                : chooseBooth.width1 * chooseBooth.width2 * chooseBooth.price
            }}</template>
            <template v-else>0</template></span
          >
          {{ currency }}
        </p>
        <p style="margin-top: 20px">
          Obligatory/固定费用: <span>{{ gudingprice }}</span
          >{{ currency }}
        </p>
        <p style="margin-top: 20px">
          Total/订单合计:
          <span style="font-size: 20px; font-weight: bold">
            <template v-if="chooseBooth">{{
              Number(
                (
                  (this.chooseBooth.width1 *
                    this.chooseBooth.width2 *
                    this.chooseBooth.price) /
                  parseInt(this.chooseBooth.boothArea)
                ).toFixed()
              ) +
              otherTotalPrice +
              gudingprice
            }}</template>
            <template v-else>{{ otherTotalPrice + gudingprice }}</template>
          </span>
          {{ currency }}
        </p>
      </div>
    </div>
    <!-- {{chooseOtherArr}} -->

    <div class="order-btn">
      <Button
        type="primary"
        size="large"
        @click="goBack"
        style="margin-right: 30px"
        class="s-btn-red"
        >Previous/上一步</Button
      >
      <Button
        type="primary"
        size="large"
        @click="goNext"
        :loading="loading"
        class="s-btn-red"
        >Save and Proceed/
        <br />
        保存并下一步</Button
      >
    </div>
    <!-- {{isAllChoose}} -->

    <iModal
      cancel-text
      title=""
      width="416"
      v-model="isChange"
      :closable="false"
      :footer-hide="true"
    >
      <div class="change-modal">
        <div class="change-modal-top">
          <Icon type="ios-alert" color="#f90" size="28" />
          <p>confirm</p>
        </div>
        <div class="change-modal-bottom">
          <p v-if="chooseBooth">
            Are you sure to quit applying {{ chooseBooth.pjName }}?？
          </p>
        </div>
        <div class="change-modal-btn">
          <Button
            type="text"
            @click="
              isChange = false;
              middleInfo = null;
            "
            >cancel</Button
          >
          <Button type="primary" @click="confirm()" style="margin-left: 10px"
            >confirm</Button
          >
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
let moment = require("moment");

export default {
  name: "order",
  data() {
    return {
      componentKey: 1,
      taskList: [],
      speenInfo: null,
      loading: false,
      list: [],
      boothList: [],
      selectedExhall: null,
      chooseBooth: null,
      otherList: [], // 线上增值服务
      otherList2: [], // 线下增值服务
      otherList3: [],
      chooseOtherArr: [], // 选中的增值服务
      isAllChoose: [], // 是否全选
      orderInfo: null,
      isChange: false,
      middleInfo: null,
      otherTotalPrice: 0,
      onlineFile: null,
      offlineFile: null,
      ChooseCheck: false,
      gudingprice: 0,
      // currency: 'USD',//货币币种
      currency: sessionStorage.getItem("currency"), //货币币种
      join: false, //是否参加过
      fixedId: 0,
      listPavilion: [],
      areaIndex: "",
      currName: "",
      deTermIdEx: "",

      dePjNameGroupName: "",
    };
  },
  components: {},
  computed: {
    exhibitionId() {
      return this.$route.query.id;
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
    groupId() {
      return this.$route.query.groupId;
    },
  },
  methods: {
    ...mapActions({
      getApplyFlow: "getApplyFlow",
      getApplyFlowSpeed: "getApplyFlowSpeed",
      getDePjNameGroup: "getDePjNameGroup",
      addApplyOrder: "addApplyOrder",
      getOrderDetail: "getOrderDetail",
      editApplyOrder: "editApplyOrder",
      getDeTerm: "getDeTerm",
      getGroupInfoById: "getGroupInfoById",
      getFile: "getFile",
      getjoin: "getjoin",

      getPavilion: "getPavilion",
      getOrderCurrency: "getOrderCurrency",

      getAllArea: "getAllArea", //获取展区列表
      getCommodities: "getCommodities", //获取商品信息
    }),

    // 获取展团
    async initPavilion() {
      let data = await this.getPavilion(this.exhibitionId); //获取展团
      if (data) {
        data.map((e, index) => {
          if (this.dePjNameGroupName == e.tname) {
            this.areaIndex = index;
            this.getOrder(e);
          }
        });
        this.listPavilion = data;
      }
      console.log(data, 1111111111);
    },
    // 重复利用的接口
    async getAllCommodities(id) {
      this.boothList = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        currencyKind: this.currencyKind == "RMB" ? "￥" : "$",
        areaId: id,
        isEnable: true,
        //   groupType: ['固定费用', '线上','线下']
      });
      this.boothList.map((c) => {
        c.width1 = 0;
        c.width2 = 0;
      });
      console.log(this.listCommodities, "获取的商品信息");
    },
    async getCost_Fixed(id) {
      this.fixedpriceAdd = 0;
      this.otherList3 = [];
      let otherList4 = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        currencyKind: this.currencyKind == "RMB" ? "￥" : "$",
        isEnable: true,
        groupType: ["固定费用"],
      });
      this.gudingprice = 0;
      otherList4.map((c) => {
        c.isPack = true;
        if (c.groupLanguage == "英文" && c.isEnable) {
          this.gudingprice += c.price;
          this.otherList3.push(c);
        }
      });

      console.log(this.otherList3, "获取的固定费用");
    },

    async getCost_onlineOffline(id) {
      this.otherList = [];
      let otherList1 = await this.getCommodities({
        exhibitionId: this.exhibitionId,
        currencyKind: this.currencyKind == "RMB" ? "￥" : "$",
        isEnable: true,
        groupType: ["线上", "线下"],
      });
      otherList1.map((c) => {
        c.isPack = false;
        c.isCheck = false;
        c.orderNum = 0;
        if (c.groupLanguage == "英文" && c.isEnable) {
          this.otherList.push(c);
        }
      });
      console.log(this.otherList, "获取的线上/下费用");
    },
    // 根据展团获取订单
    async getOrder(e) {
      this.chooseBooth = null;
      this.selectedExhall = e;
      this.getAllCommodities(e.id); //   获取商品信息

      //   this.init();
    },

    async init() {
      // 流程
      let opt = {
        ExhibitionId: this.exhibitionId,
        ApplyCompanyId: this.applyCompanyId,
      };
      let data = await this.getjoin(opt); //获取是否参加过上一届展会
      if (data.successed) {
        //
        // this.join = data.info;
      }
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;

      let info = await this.getApplyFlowSpeed(this.applyCompanyId);
      if (info && info.info) {
        this.speenInfo = info.info;
        if (this.taskList && this.taskList.length > 0) {
          this.taskList.map((c) => {
            if (this.speenInfo && this.speenInfo.speed >= c.speed) {
              c.process = true;
            }
          });
        }
      }
      // this.speenInfo不存在，即此轮流程已结束
      if (!this.speenInfo) {
        if (this.applyCompanyOrderId) {
          this.$router.push(
            "/join/basicEn?applyCompanyId=" +
              this.applyCompanyId +
              "&applyCompanyOrderId=" +
              this.applyCompanyOrderId
          );
        } else {
          this.$router.push(
            "/join/basicEn?applyCompanyId=" + this.applyCompanyId
          );
        }
      }

      // 展会下载文件
      let onlineFile = await this.getFile({
        ExhibitionId: this.exhibitionId,
        Name: "线上市场增值服务详情文件",
      });
      if (onlineFile) {
        this.onlineFile = onlineFile;
      }
      let offlineFile = await this.getFile({
        ExhibitionId: this.exhibitionId,
        Name: "Download offline value-added marketing services document",
      });
      if (offlineFile) {
        this.offlineFile = offlineFile;
      }

      // 订单信息
      let orderInfo = await this.getOrderDetail(this.applyCompanyOrderId);
      if (orderInfo && orderInfo.applyFileLink) {
        this.$router.replace("/join/finishEn");
      }
      this.orderInfo = orderInfo;
      console.log("订单信息：", this.orderInfo);
      if (this.orderInfo.isAgent === "是") {
        // 组团
        let deTerm = await this.getGroupInfoById(this.groupId);
        if (deTerm && deTerm.length) {
          if (deTerm[0].dePjNameList.length > 0) {
            this.boothList = deTerm[0].dePjNameList;
            if (this.boothList.length > 0) {
              this.boothList.map((c) => {
                c.width1 = 0;
                c.width2 = 0;
              });
            }
            this.selectedExhall = deTerm[0];
          }
          this.list = deTerm;
        }
      } else {
        console.log(sessionStorage.getItem("currency"), 1111);
        // 展位、增值服务
        let lists = await this.getAllArea(this.exhibitionId);
        //   过滤出来中文和显示且必选的
        lists = lists.filter((c) => {
          return c.languageType === "英文" && c.isEnable;
        });
        this.listPavilion = lists;
        console.log(lists, "获取展区列表");
        let areaId = lists[0].id;
        if (this.orderInfo) {
          if (this.orderInfo.applyBoothOrderList.length > 0) {
            areaId = this.orderInfo.applyBoothOrderList[0].dePjNameGroupId;
          }
        }
        this.boothList = await this.getCommodities({
          exhibitionId: this.exhibitionId,
          currencyKind: this.currencyKind == "RMB" ? "￥" : "$",
          areaId: areaId,
          isEnable: true,
        });
        this.boothList.map((c) => {
          c.width1 = 0;
          c.width2 = 0;
        });
        this.selectedExhall = lists[0];

        //如果有订单默认选中
        if (
          this.orderInfo &&
          this.orderInfo.applyBoothOrderList.length &&
          lists
        ) {
          lists.forEach((c) => {
            if (c.id == this.orderInfo.applyBoothOrderList[0].dePjNameGroupId) {
              this.selectedExhall = c;
              console.log(this.selectedExhall, "这个是选中的数据");
              //   if (this.selectedExhall.name.indexOf('其他') != -1) {
              //       this.inputShow = true
              //       this.remark = orderInfo.remark
              //   }
            }

            this.boothList.map((c) => {
              if (
                this.orderInfo &&
                this.orderInfo.applyBoothOrderList.length &&
                lists
              ) {
                if (c.name == this.orderInfo.applyBoothOrderList[0].name) {
                  //   this.boothList = c.dePjNameLis
                  this.chooseBooth = c;
                  if (this.chooseBooth) {
                    this.chooseBooth.width1 =
                      this.orderInfo.applyBoothOrderList[0].width;
                    this.chooseBooth.width2 =
                      this.orderInfo.applyBoothOrderList[0].height;
                  }
                }
              }
            });
            console.log(this.otherList, 1111);
            //   线上/线下 市场增值服务项目回显
            if (
              this.orderInfo &&
              this.orderInfo.applyOtherOrderList.length &&
              lists
            ) {
              this.chooseOtherArr = [];
              this.otherTotalPrice = 0;
              this.otherList.map((v) => {
                this.orderInfo.applyOtherOrderList.map((b) => {
                  if (
                    v.name == b.name &&
                    v.groupLanguage == "英文" &&
                    v.isEnable
                  ) {
                    v.orderNum = b.quantity;
                    v.isCheck = true;
                    v.isPack = true;
                    this.chooseOtherArr.push(v);
                    this.otherTotalPrice += b.totalPrice;
                  }
                });
              });
            }
          });
        }
      }
      console.log(this.listPavilion, "this.listPavilion");
      console.log(this.boothList, "12222223");

      //获取展位固定费用
    },
    //根据币种获取其他线上线下订单
    async getOtherList() {
      // let otherList = await this.getDePjNameGroup({
      //     "IsBoothGroup": "否",
      //     "ExhibitionId": this.exhibitionId,
      //     "Type": "线上"
      // }); // 是：展区选择展位； 否：增值服务项目
      let otherList = await this.getOrderCurrency({
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "线上",
        typeLanguage: "英文",
        ptype: sessionStorage.getItem("currency"),
        DeTermIdEx: this.deTermIdEx,
      }); // 是：展区选择展位； 否：增值服务项目
      if (otherList && otherList.length > 0) {
        otherList.map((c) => {
          c.isPack = false;
          c.isCheck = false;

          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map((d) => {
              d.orderNum = 0;
              d.durationValue = null;
              d.otherName = c.name;
              let start = new Date(d.durationBegin).getTime();
              let end = new Date(d.durationEnd).getTime();
              d.options = {
                disabledDate(date) {
                  const disabledDay = date.getTime();
                  if (disabledDay < start || disabledDay > end) {
                    return true;
                  } else {
                    return false;
                  }
                },
              };
            });
          }
        });
      }
      this.otherList = otherList;
      this.otherList.map((a) => {
        if (a.dePjNameList.length > 0) {
          a.dePjNameList.map((p) => {
            if (p.netShow == "显示且必选") {
              p.orderNum = 1;
              this.chooseOne(p);
            }
          });
        }
      });
      // let otherList2 = await this.getDePjNameGroup({
      //     "IsBoothGroup": "否",
      //     "ExhibitionId": this.exhibitionId,
      //     "Type": "线下"
      // }); // 是：展区选择展位； 否：增值服务项目
      let otherList2 = await this.getOrderCurrency({
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "线下",
        typeLanguage: "英文",
        ptype: sessionStorage.getItem("currency"),
        DeTermIdEx: this.deTermIdEx,
      }); // 是：展区选择展位； 否：增值服务项目
      if (otherList2 && otherList2.length > 0) {
        otherList2.map((c) => {
          c.isPack = false;
          c.isCheck = false;
          console.log(c.dePjNameList, "线下线下");
          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map((d) => {
              d.orderNum = 0;
              d.durationValue = null;
              d.otherName = c.name;
              let start = new Date(d.durationBegin).getTime();
              let end = new Date(d.durationEnd).getTime();
              d.options = {
                disabledDate(date) {
                  const disabledDay = date.getTime();
                  if (disabledDay < start || disabledDay > end) {
                    return true;
                  } else {
                    return false;
                  }
                },
              };
            });
          }
        });
      }

      this.otherList2 = otherList2;
      this.otherList2.map((a) => {
        if (a.dePjNameList.length > 0) {
          a.dePjNameList.map((p) => {
            if (p.netShow == "显示且必选") {
              p.orderNum = 1;
              this.chooseOne(p);
            }
          });
        }
      });
    },
    //根据币种获取固定费用
    async getGuding() {
      for (let i = 0; i < this.otherList3.length; i++) {
        if (this.otherList3[i].typeLanguage === "英文") {
          this.fixedId = i;
          for (let j = 0; j < this.otherList3[i].dePjNameList.length; j++) {
            if (this.currency == this.otherList3[i].dePjNameList[j].pType) {
              this.gudingprice =
                this.otherList3[i].dePjNameList[j].price + this.gudingprice;
            }
          }
        }
      }
      if (this.join) {
        this.allChoose(this.otherList3[this.fixedId], true);
        //this.chooseOtherArr=this.otherList3[this.fixedId].dePjNameList
        this.otherList3[this.fixedId].dePjNameList.map((e) => {
          if (e.pType == this.currency) {
            this.chooseOtherArr.push(e);
          }
        });
      } else {
        this.otherList3[this.fixedId].dePjNameList.map((e) => {
          if (e.pType == this.currency) {
            this.chooseOtherArr.push(e);
          }
        });
      }
    },
    goBack() {
      this.$router.push(
        "/join/entranceEn?applyCompanyId=" +
          this.applyCompanyId +
          "&applyCompanyOrderId=" +
          this.applyCompanyOrderId
      );
    },
    async goNext() {
      if (this.orderInfo.isAgent === "否") {
        if (!this.chooseBooth) {
          this.$Message.warning("Please select booth type/请选择展位类型");
          return;
        }
        if (!this.chooseBooth.width1 || !this.chooseBooth.width2) {
          this.$Message.warning("Please enter booth width/请输入展位宽度");
          return;
        }
      }
      if (this.orderInfo.isAgent === "是") {
        if (!this.chooseBooth) {
          this.$Message.warning("请选择组团类型");
          return;
        }
        if (!this.chooseBooth.width1 || !this.chooseBooth.width2) {
          this.$Message.warning("请输入组团宽度");
          return;
        }
      }

      //   if (this.chooseOtherArr && this.chooseOtherArr.length > 0) {
      //     console.log(this.chooseOtherArr, "chooseOtherArr");
      //     let finish = true;
      //     this.chooseOtherArr.map((c) => {
      //       if (!c.durationValue && c.durationType !== "无") {
      //         if (!c.durationValue) {
      //           finish = false;
      //           this.$Message.warning(
      //             "Please select" + c.pjName + "of" + c.durationType
      //           );
      //           return;
      //         }
      //         if (
      //           c.durationType === "时间段" &&
      //           (!c.durationValue[0] || !c.durationValue[1]) &&
      //           !c.durationValue &&
      //           c.durationType !== "无"
      //         ) {
      //           finish = false;
      //           this.$Message.warning(
      //             "Please select" + c.pjName + "of" + c.durationType
      //           );
      //           return;
      //         }
      //         if (
      //           !c.orderNum &&
      //           c.dePjNameGroupId != this.otherList3[this.fixedId].id
      //         ) {
      //           finish = false;
      //           this.$Message.warning(
      //             "Please enter" + c.pjName + "of Order quantity"
      //           );
      //           return;
      //         }
      //       }
      //     });
      //     if (!finish) return;
      //   }
      // console.log("展位：",this.chooseBooth);
      console.log("增值服务：", this.chooseOtherArr);

      let ApplyOtherOrderList = [];
      //   this.chooseOtherArr = Array.from(new Set(this.chooseOtherArr));
      //   if (this.chooseOtherArr && this.chooseOtherArr.length > 0) {
      //     this.chooseOtherArr.map((c) => {
      //       if (c.durationType === "时长") {
      //         ApplyOtherOrderList.push({
      //           ApplyCompanyOrderId: this.applyCompanyOrderId,
      //           DePjNameGroupId: c.dePjNameGroupId,
      //           DePjNameGroupName: c.otherName,
      //           Name: c.pjName,
      //           Quantity: c.orderNum,
      //           Unit: c.cunit,
      //           UnitPrice: c.price,
      //           TotalPrice: c.orderNum * c.price,
      //           MonetaryUnit: c.pType,
      //           DurationType: c.durationType,
      //           Duration: Number(c.durationValue),
      //           DurationUnit: c.durationUnit,
      //           RexMoney: c.orderNum * c.price,
      //           GpName: c.gpName || "",
      //           GpCode: c.gpCode || "",
      //           PjCode: c.pjCode || "",
      //           GroupId: c.groupId || "",
      //           PjFormat: c.pjFormat || "",
      //         });
      //       }
      //       if (c.durationType === "时间段") {
      //         ApplyOtherOrderList.push({
      //           ApplyCompanyOrderId: this.applyCompanyOrderId,
      //           DePjNameGroupId: c.dePjNameGroupId,
      //           DePjNameGroupName: c.otherName,
      //           Name: c.pjName,
      //           Quantity: c.orderNum,
      //           Unit: c.cunit,
      //           UnitPrice: c.price,
      //           TotalPrice: c.orderNum * c.price,
      //           MonetaryUnit: c.pType,
      //           DurationType: c.durationType,
      //           DurationBegin: moment(c.durationValue[0]).format("YYYY-MM-DD"),
      //           DurationEnd: moment(c.durationValue[1]).format("YYYY-MM-DD"),
      //           RexMoney: c.orderNum * c.price,
      //           GpName: c.gpName || "",
      //           GpCode: c.gpCode || "",
      //           PjCode: c.pjCode || "",
      //           GroupId: c.groupId || "",
      //           PjFormat: c.pjFormat || "",
      //         });
      //       } else {
      //         ApplyOtherOrderList.push({
      //           ApplyCompanyOrderId: this.applyCompanyOrderId,
      //           DePjNameGroupId: c.dePjNameGroupId,
      //           DePjNameGroupName: "Obligatory",
      //           Name: c.pjName,
      //           Quantity: 1,
      //           Unit: c.cunit,
      //           UnitPrice: c.price,
      //           TotalPrice: c.price,
      //           MonetaryUnit: c.pType,
      //           DurationType: c.durationType,
      //           DurationBegin: moment(c.durationBegin).format("YYYY-MM-DD"),
      //           DurationEnd: moment(c.durationEnd).format("YYYY-MM-DD"),
      //           RexMoney: c.price,
      //           GpName: c.gpName || "",
      //           GpCode: c.gpCode || "",
      //           PjCode: c.pjCode || "",
      //           GroupId: c.groupId || "",
      //           PjFormat: c.pjFormat || "",
      //         });
      //       }
      //     });
      //   }
      if (this.otherList3 && this.otherList3.length > 0) {
        this.otherList3.map((c) => {
          if (c.groupLanguage == "英文" && c.isEnable) {
            ApplyOtherOrderList.push({
              ApplyCompanyOrderId: this.applyCompanyOrderId,
              DePjNameGroupId: c.dePjNameGroupId,
              DePjNameGroupName: c.groupType,
              ThirdPartyCommodityId: c.id,
              Name: c.name,
              Quantity: 1, //填的数量
              Unit: c.unit,
              UnitPrice: c.price,
              TotalPrice: c.price,
              MonetaryUnit: c.currencyKind,
              DurationType: "",
              DurationBegin: moment(new Date()).format("YYYY-MM-DD"),
              DurationEnd: moment(new Date()).format("YYYY-MM-DD"),
              Rex: 1,
              RexMoney: c.price,
              GpName: "",
              GpCode: "",
              GroupId: 1,
              PjCode: "",
              PjFormat: "",
            });
          }
        });
      }
      if (this.chooseOtherArr && this.chooseOtherArr.length > 0) {
        this.chooseOtherArr.map((c) => {
          if (c.isCheck && c.groupLanguage == "英文") {
            ApplyOtherOrderList.push({
              ApplyCompanyOrderId: this.applyCompanyOrderId,
              DePjNameGroupId: c.dePjNameGroupId,
              DePjNameGroupName: c.groupType,
              ThirdPartyCommodityId: c.id,
              Name: c.name,
              Quantity: c.orderNum ? c.orderNum : 0, //填的数量
              Unit: c.unit,
              UnitPrice: c.price,
              TotalPrice: c.orderNum ? c.price * c.orderNum : 0,
              MonetaryUnit: c.currencyKind,
              DurationType: "",
              DurationBegin: moment(new Date()).format("YYYY-MM-DD"),
              DurationEnd: moment(new Date()).format("YYYY-MM-DD"),
              Rex: 1,
              RexMoney: c.price,
              GpName: c.kindName,
              GpCode: "",
              GroupId: 1,
              PjCode: "",
              PjFormat: "",
            });
          }
        });
      }
      let req = {};
      // 非组团
      req = {
        Id: this.applyCompanyOrderId,
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: this.exhibitionId,
        IsAgent: "否",
        ApplyBoothOrderList: [
          {
            ApplyCompanyOrderId: this.applyCompanyOrderId,
            DePjNameGroupId: this.selectedExhall.id,
            DePjNameGroupName: this.selectedExhall.nameEn,
            ThirdPartyCommodityId: this.chooseBooth.id,
            Name: this.chooseBooth.name,
            Width: this.chooseBooth.width1,
            Height: this.chooseBooth.width2,
            Area: this.chooseBooth.width1 * this.chooseBooth.width2,
            Unit: this.chooseBooth.unit,
            UnitPrice: this.chooseBooth.price,
            TotalPrice:
              this.chooseBooth.width1 *
              this.chooseBooth.width2 *
              this.chooseBooth.price,
            MonetaryUnit: this.chooseBooth.currencyKind,
            IsAgent: "否",
            Rex: 1,
            RexMoney:
              this.chooseBooth.width1 *
              this.chooseBooth.width2 *
              this.chooseBooth.price,
            GpName: this.chooseBooth.kindName,
            GpCode: "",
            GroupId: 1,
            PjCode: "",
            PjFormat: "",
            BoothType: this.chooseBooth.boothKind || "",
          },
        ],
        ApplyOtherOrderList: ApplyOtherOrderList,
      };

      if (this.chooseBooth.boothArea > 1) {
        req.ApplyBoothOrderList[0].TotalPrice = (
          (this.chooseBooth.width1 *
            this.chooseBooth.width2 *
            this.chooseBooth.price) /
          parseInt(this.chooseBooth.boothArea)
        ).toFixed();

        req.ApplyBoothOrderList[0].RexMoney = (
          (this.chooseBooth.width1 *
            this.chooseBooth.width2 *
            this.chooseBooth.price) /
          parseInt(this.chooseBooth.boothArea)
        ).toFixed();
      }
      // 组团
      //   if (this.orderInfo.isAgent === "是") {
      //     req = {
      //       Id: this.applyCompanyOrderId,
      //       ApplyCompanyId: this.applyCompanyId,
      //       ExhibitionId: this.exhibitionId,
      //       IsAgent: "是",
      //       ApplyBoothOrderList: [
      //         {
      //           ApplyCompanyOrderId: this.applyCompanyOrderId,
      //           DePjNameGroupId: this.chooseBooth.dePjNameGroupId,
      //           DePjNameGroupName: this.selectedExhall.name,
      //           Name: this.chooseBooth.pjName,
      //           Width: this.chooseBooth.width1,
      //           Height: this.chooseBooth.width2,
      //           Area: this.chooseBooth.width1 * this.chooseBooth.width2,
      //           Unit: this.chooseBooth.cunit,
      //           UnitPrice: this.chooseBooth.price,
      //           TotalPrice:
      //             this.chooseBooth.width1 *
      //             this.chooseBooth.width2 *
      //             this.chooseBooth.price,
      //           MonetaryUnit: this.chooseBooth.pType,
      //           IsAgent: "是",
      //           AgentName: this.selectedExhall.name,
      //           DeTermId: this.selectedExhall.id,
      //           RexMoney:
      //             this.chooseBooth.width1 *
      //             this.chooseBooth.width2 *
      //             this.chooseBooth.price,
      //           GpName: this.chooseBooth.gpName || "",
      //           GpCode: this.chooseBooth.gpCode || "",
      //           PjCode: this.chooseBooth.pjCode || "",
      //           GroupId: this.chooseBooth.groupId || "",
      //           PjFormat: this.chooseBooth.pjFormat || "",
      //           BoothType: this.chooseBooth.boothType || "",
      //         },
      //       ],
      //       ApplyOtherOrderList: ApplyOtherOrderList,
      //     };
      //   }

      console.log(req, "提交的数据");
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);

      if (this.speenInfo.speed < 3) {
        let info = await this.addApplyOrder(req);
        this.loading = false;
        if (info && info.successed) {
          this.$Message.success("Saved successfully！/保存成功！");
          if (this.groupId) {
            this.$router.push(
              "/join/catalogueEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&groupId=" +
                this.groupId
            );
          } else {
            this.$router.push(
              "/join/catalogueEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId
            );
          }
        }
      } else {
        let info = await this.editApplyOrder(req);
        // let info = await this.editApplyOrder({...{Id: this.orderInfo.id}, ...req});
        this.loading = false;
        if (info && info.successed) {
          this.$Message.success("Modification succeeded！/修改成功！");
          if (this.groupId) {
            this.$router.push(
              "/join/catalogueEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId +
                "&groupId=" +
                this.groupId
            );
          } else {
            this.$router.push(
              "/join/catalogueEn?id=" +
                this.exhibitionId +
                "&applyCompanyId=" +
                this.applyCompanyId +
                "&applyCompanyOrderId=" +
                this.applyCompanyOrderId
            );
          }
        }
      }
    },
    select(e) {
      if (this.chooseBooth) {
        this.isChange = true;
        this.middleInfo = e;
      } else {
        this.selectedExhall = e;
        if (e.dePjNameList.length > 0) {
          e.dePjNameList.map((c) => {
            c.width1 = 0;
            c.width2 = 0;
          });
        }
        this.boothList = e.dePjNameList;
        this.chooseBooth = null;
      }
    },
    changeNumber(item, e) {
      this.otherTotalPrice = 0;
      console.log(11111111);
      console.log(this.chooseOtherArr);
      this.chooseOtherArr.map((c) => {
        console.log(c);
        if (c.orderNum && c.price && c.isPack) {
          this.otherTotalPrice += c.orderNum * c.price;
        } else {
          this.otherTotalPrice = this.otherTotalPrice;
        }
      });
    },
    confirm() {
      this.isChange = false;
      this.selectedExhall = this.middleInfo;
      if (this.middleInfo.dePjNameList.length > 0) {
        this.middleInfo.dePjNameList.map((c) => {
          c.width1 = 0;
          c.width2 = 0;
        });
      }
      this.boothList = this.middleInfo.dePjNameList;
      this.chooseBooth = null;
    },
    choose(e) {
      this.chooseBooth = e;
      //   this.currency = e.pType;
      //   this.gudingprice = 0;

      //   this.ApplyOtherOrderList = [];
      //   this.chooseOtherArr = [];
      //   this.otherTotalPrice = 0;
      //   this.getGuding();
      //   this.getOtherList();
      console.log(e, "展位选择");
    },
    changeWidth1(e, i) {
      console.log(i, "23123123");
      this.$set(this.boothList, i, this.boothList[i]);
    },
    changeWidth2(e, i) {
      console.log(i, "wwwww");
      this.$set(this.boothList, i, this.boothList[i]);
    },
    allChoose(e, value) {
      // console.log(this.isAllChoose, 'eeeeeeeee')
      console.log(this.chooseOtherArr, "666666");
      if (value) {
        e.isPack = true;
      } else {
        e.isPack = false;
      }
      this.componentKey++;

      const exists = this.chooseOtherArr.some((item) => item.id === e.id);
      if (exists) {
        this.chooseOtherArr.forEach((element, index) => {
          if (element.id == e.id) {
            this.chooseOtherArr.splice(index, 1);
          }
        });
      } else {
        this.chooseOtherArr.push(e);
      }
      this.otherTotalPrice = 0;
      if (
        this.chooseOtherArr &&
        this.chooseOtherArr.length > 0 &&
        e.type != "固定费用"
      ) {
        this.chooseOtherArr.map((c) => {
          if (c.orderNum && c.price && c.isPack) {
            this.otherTotalPrice += c.orderNum * c.price;
          }
        });
      } else if (
        this.chooseOtherArr &&
        this.chooseOtherArr.length > 0 &&
        e.type == "固定费用"
      ) {
        //this.otherTotalPrice =this.gudingprice
      } else {
        this.otherTotalPrice = 0;
      }
    },
    chooseOne(e, index) {
      // 如果为true，则为选中，否则为取消选中
      if (e.isCheck) {
        this.otherList[index].isCheck = false;
      } else {
        this.otherList[index].isCheck = true;
      }

      this.componentKey++;

      const exists = this.chooseOtherArr.some((item) => item.id === e.id);
      if (exists) {
        this.chooseOtherArr.forEach((element, index) => {
          if (element.id == e.id) {
            this.chooseOtherArr.splice(index, 1);
          }
        });
      } else {
        this.chooseOtherArr.push(e);
      }
      this.otherTotalPrice = 0;
      this.otherTotalPrice = 0;
      if (this.chooseOtherArr && this.chooseOtherArr.length > 0) {
        this.chooseOtherArr.map((c) => {
          if (c.orderNum && c.price && c.isPack) {
            this.otherTotalPrice += c.orderNum * c.price;
          } else {
            this.otherTotalPrice = this.otherTotalPrice;
          }
        });
        //this.otherTotalPrice=this.otherTotalPrice+this.gudingprice
      } else {
        this.otherTotalPrice = 0;
      }
    },
  },
  created() {
    this.dePjNameGroupName = this.$route.query.dePjNameGroupName;

    // this.initPavilion();

    this.currencyKind = sessionStorage.getItem("currency");
    this.init();
    this.getCost_Fixed();
    this.getCost_onlineOffline();
    // this.initPavilion();
  },
};
</script>

<style scoped lang='scss'>
.order {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;

    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;

      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px #00bdca59;
        border-radius: 50%;
        margin-top: 10px;

        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }

    .line {
      height: 8px;
      background-color: #d7e2e4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }

    .ing {
      color: #00bdca;

      .box {
        div {
          background-color: #00bdca;
        }
      }
    }

    .finished {
      color: #00bdca;

      .box {
        background-color: #00bdca;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #00bdca;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-exhall {
    padding: 30px 30px 0 30px;
    background-color: #fff;

    .exhall-header {
      width: 100%;
      height: 46px;
      background-color: #e5f8fa;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }

    .exhall-list {
      display: flex;
      flex-wrap: wrap;
      padding: 20px 0 15px;
      background-color: #fff;

      .list-one {
        padding: 4px 20px;
        border: solid 1px #999;
        margin: 0 15px 15px 0;
        border-radius: 5px;
        cursor: pointer;
      }

      .selected {
        background-color: #b1262d;
        border: solid 1px #b1262d;
        color: #fff;
      }
    }

    .booth-list {
      background-color: #fff;
      padding: 20px 0 10px 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .booth-one {
        width: 560px;
        height: 230px;
        background-color: #f5f5f5;
        margin-bottom: 20px;
        padding: 20px;
        position: relative;
        cursor: pointer;

        .f {
          display: flex;
          justify-content: space-between;

          p {
            width: 50%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 20px;
            color: #333;
          }

          p:last-child {
            text-align: right;
            font-size: 14px;
          }
        }

        .s {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #333;
          }

          p:last-child {
            text-align: right;
            font-size: 24px;
            color: #ff0000;
          }
        }

        .t {
          margin-top: 10px;
          color: #333;
        }

        .l {
          color: #333;
          font-size: 16px;
          margin-top: 30px;
        }

        .choose {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border-bottom: 46px solid #d9d9d9;
          border-left: 46px solid transparent;

          i {
            position: absolute;
            top: 10px;
            left: -30px;
            color: #fff;
            font-size: 30px;
          }
        }

        .choosed {
          border-bottom: 46px solid #b1262d;
        }
      }

      .chooseboothOne {
        border: 1px solid red;
      }
    }
  }

  &-other {
    background-color: #fff;
    padding: 0 30px 30px;

    .other-header {
      width: 100%;
      height: 46px;
      background-color: #e5f8fa;
      color: #333;
      font-size: 18px;
      line-height: 46px;
      padding-left: 20px;
      font-weight: bold;
    }

    .other-online {
      padding: 0 30px;
      margin-bottom: 30px;
      font-size: 16px;

      a {
        text-decoration: underline;
      }
    }

    .other-list {
      width: 1080px;
      margin: 0 auto 30px;
      border: solid 1px #e5e5e5;
      //border: solid 1px #e5e5e5;
      .top {
        background-color: #f5f5f5;
        height: 46px;
        line-height: 46px;
        position: relative;
        padding: 0 20px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        border-bottom: 1px solid #e5e5e5;

        .r {
          cursor: pointer;
          display: flex;
          align-items: center;

          i {
            font-size: 20px;
            margin-left: 5px;
          }
        }
      }

      .content {
        padding: 20px 20px 0 20px;

        .content-one {
          width: 100%;
          margin: 0 auto 20px;
          border: 1px solid #e5e5e5;

          .title {
            width: 100%;
            height: 46px;
            background-color: #f5f5f5;
            line-height: 46px;
            font-size: 16px;
            color: #333;
            padding-left: 20px;
            border-bottom: 1px solid #e5e5e5;
          }

          .details {
            width: 100%;
            height: 230px;
            display: flex;

            .text {
              width: 50%;
              height: 100%;
              padding: 0 30px;
              position: relative;
              cursor: pointer;
              color: #333;
              font-size: 16px;

              .time {
                width: 100%;
                display: flex;
                align-items: center;
                margin-top: 20px;

                span {
                  width: 200px;
                }
              }

              .choose {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 0;
                height: 0;
                border-bottom: 46px solid #d9d9d9;
                border-left: 46px solid transparent;

                i {
                  position: absolute;
                  top: 10px;
                  left: -30px;
                  color: #fff;
                  font-size: 30px;
                }
              }

              .choosed {
                border-bottom: 46px solid #b1262d;
              }
            }

            img {
              width: 50%;
              height: 100%;
            }
          }
        }
      }
    }

    .total {
      width: 100%;
      height: 173px;
      background-color: #f5f5f5;
      border: solid 1px #e5e5e5;
      text-align: right;
      font-size: 16px;
      color: #333;
      padding: 30px;

      p {
        line-height: 1;
      }

      span {
        color: #b1262d;
      }
    }
  }

  &-btn {
    margin-top: 50px;
    margin-bottom: 80px;
    text-align: center;

    button {
      width: 200px;
      height: 48px;
      background-color: #024c8b;
      font-size: 16px;
      border-color: #024c8b;
    }
  }
}

.change-modal {
  padding: 6px 16px 8px;

  &-top {
    display: flex;
    align-items: center;

    p {
      padding-left: 12px;
      color: #17233d;
      font-size: 16px;
      line-height: 42px;
    }
  }

  &-bottom {
    margin-left: 40px;
  }

  &-btn {
    text-align: right;
    margin-top: 20px;
  }
}

.tabs {
  // margin-bottom: 30px;

  &-top {
    color: #666;
    background: rgb(245, 245, 245);
    margin-top: 20px;
    padding: 20px;
    font-style: 18px;

    .tag {
      // width: 270px;
      line-height: 33px;
      text-align: center;
      margin-top: 5px;
      background-blend-mode: normal, normal;
      border-bottom: none;
      cursor: pointer;
      position: relative;
      background-color: rgba(255, 255, 255, 1);

      border-left: solid 1px rgba(212, 212, 212, 1);
      border-right: solid 1px rgba(212, 212, 212, 1);
      border-top: solid 1px rgba(212, 212, 212, 1);
      border-bottom: solid 1px rgba(212, 212, 212, 1);
      border-radius: 5px 5px 5px 5px;
      overflow: hidden;

      span {
        position: relative;
        z-index: 1;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      &:hover,
      &.active {
        background-color: transparent;
        color: #fff;

        &::before {
          // background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
          background-image: linear-gradient(-90deg, #18c1cd 0%, #00bdca 100%),
            linear-gradient(#f2f2f2, #f2f2f2);
        }
      }
    }
  }

  &-bottom {
    border: solid 1px #4f9edd;
    padding: 20px 20px 0;

    .item {
      cursor: pointer;
      width: 100%;
      text-align: center;
      font-size: 14px;
      line-height: 32px;
      border-radius: 5px;
      background-color: #f7f7f7;
      color: #666;
      margin-bottom: 20px;
      overflow: hidden;
      padding: 0 5px;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.active {
        background-color: #4f9edd;
        color: #fff;
      }
    }
  }
}
</style>
